import React from 'react'
import { dispatch } from '../helpers/store'
import { initSocialNetworks, socialSharePost } from '../actions'

export default ({ message, link, deal_id: dealId, deal_gift_id: dealGiftId, redirect_url: redirectUrl }) => {
  dispatch(initSocialNetworks())
  const provider = 'vkontakte'
  const shareAction = socialSharePost({ message, link, dealId, dealGiftId, provider, redirectUrl })
  return <a
    href='#'
    className='btn-login-base vk'
    onClick={ () => dispatch(shareAction) } >
    <strong></strong>
    <span>Поделиться</span>
  </a>
}



// WEBPACK FOOTER //
// app/javascript/src/components/socialShareLinkVk.jsx